// ============================================================
// actingBy (v8.363.2): who acts as whom, from the seats. One person may
// hold several seats over a night; the newest seat that names a
// combatant speaks for them. Pure.
// ============================================================
export interface SeatLike {
  uid?: string;
  actingAs?: unknown;
  lastSeen?: unknown;
}

export function actingByFrom(seats: readonly SeatLike[], toMs: (v: unknown) => number): Record<string, string> {
  const newest = new Map<string, { at: number; combatantId: string }>();
  for (const s of seats) {
    if (!s.uid || typeof s.actingAs !== 'string' || !s.actingAs) continue;
    const at = toMs(s.lastSeen);
    const had = newest.get(s.uid);
    if (!had || at >= had.at) newest.set(s.uid, { at, combatantId: s.actingAs });
  }
  const out: Record<string, string> = {};
  for (const [uid, { combatantId }] of newest) out[uid] = combatantId;
  return out;
}
